module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('y-shelf', {
    attrs: {
      "title": "基本信息"
    }
  }, [_c('span', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "avatar-box"
  }, [_c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    attrs: {
      "src": _vm.user.avatar == '' ? '/static/images/default.png' : _vm.user.avatar
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "r-box"
  }, [_c('h3', {
    staticStyle: {
      "margin-left": "13px"
    }
  }, [_vm._v("修改头像")]), _vm._v(" "), _c('y-button', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "text": "上传头像",
      "classStyle": "main-btn"
    },
    on: {
      "btnClick": function($event) {
        return _vm.editAvatar()
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "30px 30px 30px 40px"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('label', {
    staticStyle: {
      "letter-spacing": "1.3px"
    },
    attrs: {
      "for": "contact"
    }
  }, [_vm._v("联系人姓名")]), _c('span', [_vm._v("：")]), _vm._v("\n               "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.user.contact
    }
  })]), _vm._v(_vm._s(_vm.user.nickname) + "\n            "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.user.userType == '10') ? _c('label', {
    staticStyle: {
      "letter-spacing": "3.01px"
    },
    attrs: {
      "for": "nickname"
    }
  }, [_vm._v("工厂/诊所：")]) : _vm._e(), _vm._v(" "), (_vm.user.userType == '20') ? _c('label', {
    staticClass: "four",
    attrs: {
      "for": "nickname"
    }
  }, [_vm._v("所属地区：")]) : _vm._e(), _vm._v(" "), (_vm.user.userType == '10') ? _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.user.nickName
    }
  }) : _vm._e(), _vm._v(" "), (_vm.user.userType == '20') ? _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.user.location
    }
  }) : _vm._e(), _vm._v(" "), (_vm.user.userType == '99') ? _c('label', {
    staticClass: "four",
    attrs: {
      "for": "location"
    }
  }, [_vm._v("所属地区：")]) : _vm._e(), _vm._v(" "), (_vm.user.userType == '99') ? _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "未知",
      "disabled": "disabled"
    }
  }) : _vm._e()])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('label', {
    staticClass: "four",
    attrs: {
      "for": "mobile"
    }
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.user.mobile
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('label', {
    staticClass: "four",
    attrs: {
      "for": "loginDate"
    }
  }, [_vm._v("注册时间：")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.user.createTime
    }
  })])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "gutter": 30
    }
  }, [(_vm.user.userType == '10') ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('label', {
    staticClass: "four",
    attrs: {
      "for": ""
    }
  }, [_vm._v("所属地区：")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.user.location
    }
  })]) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('label', {
    staticClass: "four",
    attrs: {
      "for": ""
    }
  }, [_vm._v(_vm._s(_vm.user.userType == '20' ? '总接单数' : '发单次数') + "：")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.user.demServType != '99' ? _vm.user.demTotalCount : _vm.user.desTotalCount) + '单'
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('label', {
    staticClass: "four",
    attrs: {
      "for": ""
    }
  }, [_vm._v("完成订单：")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.user.demServType != '99' ? _vm.user.demFinishCount : _vm.user.desFinishCount) + '单'
    }
  })]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.userType == '20'),
      expression: "user.userType=='20'"
    }],
    attrs: {
      "span": 12
    }
  }, [_c('label', {
    staticClass: "four",
    attrs: {
      "for": ""
    }
  }, [_vm._v("服务等级：")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.desLevel
    }
  })]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.userType == '20'),
      expression: "user.userType=='20'"
    }],
    attrs: {
      "span": 12
    }
  }, [_c('label', {
    staticClass: "three",
    attrs: {
      "for": ""
    }
  }, [_vm._v("服务值：")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "margin-left": "-5px"
    },
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.user.desFinishCount + (_vm.user.desFinishCount < 1000 ? '/1000' : '/5000')
    }
  })]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.userType == '10'),
      expression: "user.userType=='10'"
    }],
    attrs: {
      "span": 12
    }
  }, [_c('label', {
    staticClass: "three",
    attrs: {
      "for": ""
    }
  }, [_vm._v("总支出：")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "margin-left": "-5px"
    },
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.user.demTotalAmount + '元'
    }
  })])], 1)], 1), _vm._v(" "), (_vm.editAvatarShow) ? _c('div', {
    staticClass: "edit-avatar"
  }, [_c('y-shelf', {
    attrs: {
      "title": "设置头像"
    }
  }, [_c('span', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('span', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.editAvatarShow = false
      }
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "t": "1501234940517",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": "3014",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "20",
      "height": "20"
    }
  }, [_c('path', {
    attrs: {
      "d": "M941.576 184.248l-101.824-101.824L512 410.176 184.248 82.424 82.424 184.248 410.168 512l-327.744 327.752 101.824 101.824L512 613.824l327.752 327.752 101.824-101.824L613.832 512z",
      "fill": "#cdcdcd",
      "p-id": "3015"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "content",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "edit-l"
  }, [_c('div', {
    staticStyle: {
      "width": "100px",
      "height": "100px",
      "border": "1px solid #ccc",
      "margin-bottom": "20px",
      "overflow": "hidden",
      "background-color": "black"
    }
  }, [_c('div', {
    staticClass: "show-preview",
    style: ({
      'width': _vm.previews.w + 'px',
      'height': _vm.previews.h + 'px',
      'overflow': 'hidden',
      'zoom': _vm.option.zoom
    })
  }, [_c('div', {
    style: (_vm.previews.div)
  }, [_c('img', {
    style: (_vm.previews.img),
    attrs: {
      "src": _vm.option.img
    }
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px 0"
    }
  }, [_vm._v("头像预览")]), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("重新选择")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "value": "上传头像"
    },
    on: {
      "change": function($event) {
        return _vm.upimg($event)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "edit-r"
  }, [_c('div', [(_vm.option.img) ? _c('div', {
    staticClass: "big",
    attrs: {
      "id": "cropper-target"
    }
  }, [_c('vueCropper', {
    ref: "cropper",
    attrs: {
      "img": _vm.option.img,
      "outputSize": _vm.example2.size,
      "info": _vm.example2.info,
      "canScale": _vm.example2.canScale,
      "autoCrop": _vm.example2.autoCrop,
      "autoCropWidth": _vm.example2.width,
      "autoCropHeight": _vm.example2.height,
      "fixed": _vm.example2.fixed
    },
    on: {
      "realTime": _vm.realTime
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "bootom-btn pa"
  }, [_c('y-button', {
    staticStyle: {
      "width": "140px",
      "height": "40px",
      "line-height": "40px"
    },
    attrs: {
      "text": "取消"
    },
    on: {
      "btnClick": function($event) {
        _vm.editAvatarShow = false
      }
    }
  }), _vm._v(" "), _c('y-button', {
    staticStyle: {
      "width": "140px",
      "height": "40px",
      "line-height": "40px"
    },
    attrs: {
      "text": "确定",
      "classStyle": "main-btn"
    },
    on: {
      "btnClick": _vm.cropper
    }
  })], 1)])])], 1) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42ae91dc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/User/children/information.vue
// module id = 642
// module chunks = 0